/**
 * Resolves the copy to show on the mWeb login button for the `m_web_login_button_variants`
 * experiment (GATE-1359).
 *
 * - Variant B (LOG_IN) reuses the existing translated `login` string.
 * - Variant C (SIGN_IN) has no translation yet, so its copy is hardcoded English.
 *
 * Returns `null` when the experiment does not apply (control variant, or an
 * unrecognised value), in which case callers should fall back to the unchanged
 * icon-only button (variant A / control).
 *
 * @param loginButtonVariant - The raw value of the `m_web_login_button_variants` config flag.
 * @param loginText - The translated `login` string, used for variant B.
 * @returns The copy for the variant, or `null` if it does not apply.
 */
const getLoginButtonVariantCopy = (
  loginButtonVariant: string | undefined,
  loginText: string,
): string | null => {
  if (loginButtonVariant === 'B') {
    return loginText;
  }

  if (loginButtonVariant === 'C') {
    return 'Sign in'; // hardcoded English copy for variant C
  }

  return null;
};

export default getLoginButtonVariantCopy;
